customElements.define(
  'bundle-button',
  class BundleButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const links = this.querySelectorAll('a');
      const firstButton = links[0];
      const secondButton = links[1];

      if (firstButton) {
        firstButton.addEventListener('click', (event) => {
          event.preventDefault();
          const target = document.getElementById('SetProductSupplies');
          if (target) {
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        });
      }

      if (secondButton) {
        secondButton.addEventListener('click', (event) => {
          event.preventDefault();
          window.print();
        });
      }
    }
  }
);

customElements.define(
  'auto-top',
  class AutoTop extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const header = document.querySelector('header');
      const toolbar = this;

      if (!header || !toolbar) return;

      const updateTop = () => {
        const headerHeight = header.offsetHeight + 25;
        toolbar.style.top = `${headerHeight}px`;
      };

      updateTop();
      window.addEventListener('resize', updateTop);

      const observer = new ResizeObserver(updateTop);
      observer.observe(header);
    }
  }
)